// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__zX-So","modal":"Modal_modal__S2vGO","closeButton":"Modal_closeButton__5+kyg"};